<template>
  <div>
    <div class="bg-white load-ar">
        <!--表格-->
        <div>
          <el-table
            class="table-inquiry"
            :data="orderList"
            ref="tableRef"
            :cell-style="{whiteSpace: 'pre-wrap'}"
            border
            :span-method="objectSpanMethod"
            style="width: 100%;"
            :height="orderList.length >6 ? `calc( 100vh - ${confirm?300:460}px )` : orderList.length * 118+50 + 'px'"
            >
            <!--确认单时删除最后一个列-->
          <el-table-column v-for="(item,index) in confirm?tableData.slice(0,-1):isAdmin?isAdmintableData:tableData" :key="index" :prop="item.prop" :label="item.name" :width="item.width" :min-width="item.minWidth" header-align="center" :sortable="item.sortable" :resizable="false">
            <!-- 自定义表头 -->
            <template slot="header" slot-scope="scope">
              <span>{{ scope.column.label }}</span>
            </template>
            <template slot-scope="scope">
              <!--订单报价-->
              <div :class="{'text-center':item.center,'text-left':isAdmin}"   v-if="item.pattern==='store_list'" class="text-ell">
                <!--住宿订单-->
                <div v-if="scope.row.order_type==1" class="text-ellipsis">
                    <div class="room-type">
                        <div class="room-list" v-if="scope.row.room_need_arr.mode==0">
                            <template v-for="(room,index) in scope.row.room_need_arr.list">
                                <div  :key="index" class="room-item" v-if="index<1">
                                    <div>
                                        <div>
                                            <span class="room-img">
                                                <img :src="`/images/fx/icon_${room.type}.png`" class=" cursor-pointer mr-1"  >
                                            </span>
                                            <span v-if="room.offer_title" class="offer_title">{{room.offer_title}}</span>
                                            <span v-else class="offer_title">{{room.type| formatVar('roomStyle')}}</span>
                                        </div>
                                        <div class="room-num">
                                            <span class="ml-1">{{room.room_num}}间</span>   
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                        <div class="room-list" v-else>
                            <template v-for="(item,index) in scope.row.room_need_arr.list">
                                <div  :key="index" class="room-item" v-if="index<2">
                                    <template v-for="(room,room_index) in item.offer_info">
                                        <div  :key="room_index" v-if="room_index<1">
                                            <div>
                                                <span class="room-img">
                                                    <img :src="`/images/fx/icon_${room.type}.png`" class=" cursor-pointer mr-1">
                                                </span>
                                                <span v-if="room.offer_title" class="offer_title">{{room.offer_title}}</span>
                                                <span v-else class="offer_title">{{room.type| formatVar('roomStyle')}}</span>
                                            </div>
                                            <div class="room-num">
                                                <span class="ml-1">{{room.room_num}}间</span>   
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </template>
                            <div class="text-center" style="height: 8px; line-height: 8px; color:#999" v-if="scope.row.room_need_arr.list.length>2||scope.row.room_need_arr.list[0].offer_info.length>1">...</div>
                        </div>
                    </div>
                </div>
              </div>
                <!--住宿价格-->
              <div :class="{'text-center':item.center,'text-left':isAdmin}"   v-if="item.pattern==='offer_price'" class="text-ell">
                <div class="room-list" v-if="scope.row.room_need_arr.mode==0">
                    <template v-for="(room,index) in scope.row.room_need_arr.list">
                        <div  :key="index"  v-if="index<1">
                            <div>
                                <div class="offer_price mt-1">
                                    <span class="reds" v-if="room.offer_price"><span>¥</span>144{{room.offer_price}}</span> 
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <div v-else-if="scope.row.order_type==1" class="text-ellipsis">
                    <div class="room-type no-border">
                        <div class="room-list">
                            <template v-for="(item,index) in scope.row.room_need_arr.list">
                                <div  :key="index"  v-if="index<2">
                                    <template v-for="(room,room_index) in item.offer_info">
                                        <div  :key="room_index" v-if="room_index<1">
                                            <div class="offer_price mt-1">
                                                <span class="reds" v-if="room.offer_price"><span>¥</span>{{room.offer_price}}</span> 
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
              </div>
                <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='oid'">
                    <div >{{scope.row.title}}</div>
                    <div class="tiem-oid">{{scope.row[item.prop]}}</div>
                    <div class="tiem-oid">{{scope.row.add_time | formatTimestamp(1)}}</div>
                    
                </div>
                <!--入离时间-->
                <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='date_in'">
                   <div class="flex " v-if="scope.row.order_type==1">
                        <div>
                            <div>
                                <span class="el-icon-room">入：</span>
                                <span class="date-tiem datein"><span >{{scope.row.date_in | formatTimestamp(2)}}</span> </span>
                            </div>
                            <div class="mt-2">
                                <span class="el-icon-room">离：</span>
                                <span class="date-tiem datein"> <span>{{scope.row.date_out | formatTimestamp(2)}}</span> </span>
                            </div>
                        </div>
                    </div>
                     <!--纯会订单-->
                    <div v-else>
                        <template v-for="(item,index) in scope.row.meeting_need_arr.list">
                            <div  :key="index" v-if="index<1" class="text-ellipsis">
                                <div>
                                    <div>
                                        <span class="el-icon-room"><i class="el-icon-date"></i>开会日期：</span>
                                        <span class="date-tiem"><span class="datein">{{item.date | formatTimestamp(2)}}</span></span>
                                    </div>
                                    <div class="mt-2">
                                        <span class="el-icon-room"><i class="icon-qitafuwu iconfont"></i>布&emsp;&emsp;局：</span>
                                        <span class="date-tiem"><span>{{item.type | formatVar('LayoutTypes')}}</span></span>
                                    </div>
                                </div>
                                <div  class="ml-4">
                                    <div>
                                        <span class="el-icon-room"><i class="icon-shijian iconfont"></i>时&ensp;间&ensp;段：</span>
                                        <span class="date-tiem min-wdei"><span >{{item.timeslot| formatVar('TimeSlots')}}</span></span>
                                    </div>
                                    <div class="mt-2">
                                        <span class="el-icon-room"><i class="icon-mianji2 iconfont"></i>要求面积：<span class="date-tiem">{{item.area}} ㎡</span> </span>  
                                    </div>
                                </div>
                                 <div class="ml-4"> 
                                    <div>
                                        <span class="el-icon-room"><i class="icon-geren iconfont"></i>人&emsp;&emsp;数：<span class="date-tiem">{{item.num}} 人</span> </span>  
                                    </div>
                                    <div class=" mt-2 meet-red" v-if="item.offer_title">
                                        <span class="el-icon-room "><i class="icon-huiyi1 iconfont"></i>会&ensp;议&ensp;室：<span class="date-tiem">{{item.offer_title}} <span class="ml-2 red"><span>¥</span>{{item.offer_price}}</span> </span></span>   
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
                <!--人数-->
                <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='num'">
                   <div class="flex ">
                        <div class="mt-2">
                            <span class="el-icon-room"><span class="date-tiem">{{scope.row.num}} 人</span> </span>
                        </div>
                        <div class="mt-2 dlis">
                            <span class="datein text-fw">{{((scope.row.date_out - scope.row.date_in)/86400).toFixed(0)}}</span> 晚
                        </div>
                    </div>
                </div>
                <div :class="{'text-center':item.center,'leftAndRight':isAdmin}"  v-else-if="item.pattern==='hotel_title'" class="hotel-info-title">
                    <!--酒店-->
                    <template v-if="storeInfo.type==2||isAdmin">
                        <div class="hotel-info"   :class="{'hotel-isdmin':isAdmin}" v-if="scope.row.hotel_top_pic">
                            <img v-lazy="$GFUN.formatImgSrc(scope.row.hotel_top_pic,66,66)" class="hotel-img cursor-pointer mr-3"  :key="scope.row.hotel_top_pic">
                            <div class="hotel-title" >
                                <div class="hotel-name">
                                    <h4>{{scope.row[item.prop]| formatString(isAdmin?8:12)}}</h4>
                                </div>
                                <div class="offer_name" v-if="scope.row.offer_name">
                                    <div class="offer_lis">
                                        <i class="icon-kehu iconfont"></i>{{scope.row.offer_name}}
                                    </div>
                                    <div><i class="icon-dianhua iconfont"></i>{{ scope.row.offer_mobile }}</div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="hotel-info">
                            <img src="/images/public/logo.png" class="hotel-img cursor-pointer mr-3"  :key="scope.row.hotel_top_pic">
                            <h4>订单未成交</h4>
                        </div>
                    </template>
                    <!--采购商-->
                    <div class="hotel-info" v-if="storeInfo.type==3" :class="{'hotel-isdmin':isAdmin}">
                        <img src="/images/public/logo.png" class="hotel-img cursor-pointer mr-3"  :key="scope.row.hotel_top_pic">
                        <template v-if="scope.row.send_name">
                            <div class="hotel-title">
                                <div class="hotel-name">
                                    <h4 v-if="scope.row.travel_title==scope.row.send_name">个人用户</h4>
                                    <h4 v-else>{{scope.row.travel_title| formatString(isAdmin?8:12)}}</h4>
                                </div>
                                <div class="offer_name">
                                    <div><i class="icon-kehu iconfont"></i>{{scope.row.send_name}}</div>
                                    <div><i class="icon-dianhua iconfont"></i>{{ scope.row.send_mobile }}</div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div>{{scope.row.send_type==2?'等待供应商确认':'等待采购商确认'}}</div>
                        </template>
                    </div>
                </div>
                <div :class="{'text-center':item.center,'leftAndRight':isAdmin}"  v-else-if="item.pattern==='supplier_title'" class="hotel-info-title">
                    <!--采购商-->
                    <div class="hotel-info" v-if="storeInfo.type==3||isAdmin" :class="{'hotel-isdmin':isAdmin}">
                        <img src="/images/public/logo.png" class="hotel-img cursor-pointer mr-3"  :key="scope.row.hotel_top_pic">
                        <template v-if="scope.row.send_name">
                            <div class="hotel-title">
                                <div class="hotel-name">
                                    <h4 v-if="scope.row.travel_title==scope.row.send_name">个人用户</h4>
                                    <h4 v-else>{{scope.row.travel_title| formatString(isAdmin?8:12)}}</h4>
                                </div>
                                <div class="offer_name">
                                    <div><i class="icon-kehu iconfont"></i>{{scope.row.send_name}}</div>
                                    <div><i class="icon-dianhua iconfont"></i>{{ scope.row.send_mobile }}</div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div>{{scope.row.send_type==2?'等待供应商确认':'等待采购商确认'}}</div>
                        </template>
                    </div>
                </div>
                <!--订单类型-->
                <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='order_type'">
                    <el-tooltip class="item" effect="dark" :content="`发单人：${scope.row.send_type==3?scope.row.offer_name:scope.row.send_name}`" placement="top-start">
                        <div>
                            <span class="text-psis mb-2 text-direct cursor-pointer" v-if="scope.row.appoint_store_id*1>0">{{scope.row.ask_type==1?'确&ensp;认&ensp;单':'定&emsp;&emsp;向'}}</span>
                        </div>
                    </el-tooltip>
                    <div>
                        <span class="text-psis">
                            {{ scope.row[item.prop]==1?'住宿订单':'纯会订单'}}
                        </span>
                    </div>      
                </div>
                <!--团号-->
                <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='title'" class="travel_title">
                        <img  src="/images/public/logo.png" style="width: 64px;height: 64px" class="hotel-img">
                        <div class="">
                            <span>{{ scope.row.travel_title }}</span>
                            <p>{{scope.row[item.prop]}}</p>
                        </div> 
                    </div>
                <!--时间-->
                <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='time'">{{ scope.row[item.prop]| formatTimestamp(1)}}</div>
                <!-- 核房/支付人-->
                <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='verify_arr'" class="verify_arr">
                    <!--核房人-->
                        <div>
                            <div v-if="scope.row.verify_arr.length>0">
                            <template v-for="(item,index) in scope.row.verify_arr">
                                <div  :key="index" class="verify-item" v-if="index<2">
                                    <el-tooltip class="item" effect="dark" :content="`手机号：${item.mob}`" placement="top-start">
                                        <span class="verify-type">
                                            <i class="icon-yonghu-tianchong iconfont"></i>
                                            <span class="text-psoman">{{item.flag==1?'导游':'领队'}}</span>
                                            <span class="verify-name">{{item.title}}</span>
                                        </span>
                                    </el-tooltip>
                                </div>
                            </template>
                        </div>
                        <div v-else class="not-added">未添加</div>  
                    </div>
                    <!--支付人-->
                    <div>
                        <div v-if="scope.row.pay_arr.length>0">
                            <div v-for="(item,index) in scope.row.pay_arr" :key="index" class="verify-item">
                                <el-tooltip class="item" effect="dark" :content="`手机号：${item.mob}`" placement="top-start">
                                    <span class="verify-type">
                                        <i class="icon-yonghu-tianchong iconfont"></i>
                                        <span class="text-psoman">{{item.flag==1?'导游':'领队'}}</span>
                                        <span class="verify-name">{{item.title}}</span>
                                    </span>
                                </el-tooltip>
                            </div>
                        </div>
                        <div v-else class="not-added">未添加</div>  
                    </div>
                </div>
                <!-- 订单状态-->
                <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='status'">
                    <span class="text-status"  :class="getStatusClass(scope.row.status||scope.row.offer_status)">
                        {{(scope.row.status||scope.row.offer_status)|formatVar(orderStatusArr())}}
                    </span>
                    <!--订单修改-->
                    <div v-if="scope.row.edit_status==1||scope.row.cancel_status==1" class="modify mt-1">
                        <span v-if="isAdmin">{{scope.row.edit_launch_uid==scope.row.offer_uid?scope.row.offer_name:scope.row.send_name}}发起 {{scope.row.cancel_status==1?'取消':'修改'}}</span>
                        <span v-else> {{ scope.row.edit_launch_uid==userLoginMessage.uid?storeInfo.type==2?scope.row.send_name:scope.row.offer_name:storeInfo.type==2?scope.row.offer_name:scope.row.send_name}}发起 {{scope.row.cancel_status==1?'取消':'修改'}}</span>
                    </div>
                    <div v-if="scope.row.edit_status==1||scope.row.cancel_status==1" class="mt-1 dlestl">
                        <span class="links ml-2 ">待处理<a>1</a></span>
                    </div>
                    <p class="text-cancel" v-if="scope.row.status==99">( {{ scope.row.cancel_remark}} )</p>  
                </div>
                <!-- 标记信息-->
                <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='mark_info'">
                    <template v-for="(item,index) in travel" >
                    <div class="straveln"  :key="index" v-if="showCommentBtn(item.type)&&scope.row.offer_status!=0&&!isGroup">
                        <span v-if="storeInfo.type==99" class="quan">{{item.name}}</span>
                        <el-tooltip class="item" content="编辑标记信息,仅自己可见" placement="top-start">
                            <span v-if="userInfo.type==3">
                                <i v-if="!$GFUN.isInArray([1],scope.row.offer_status)&&!$GFUN.isInArray([99,97],scope.row.offer_status)||scope.row.hotel_flag!=0" class="el-icon-s-flag" :class="flagson(item.type,scope.row)" @click="$emit('getOrderFlag',scope.row,item.type)"></i> 
                            </span>
                            <span v-if="userInfo.type==2||storeInfo.type==99" @click="$emit('getOrderFlag',scope.row,item.type)">
                                <i  class="el-icon-s-flag" :class="flagson(item.type,scope.row)" ></i> 
                            </span>
                        </el-tooltip>
                    </div>
                    </template>
                </div>
                <!-- 订单金额-->
                <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='price'">
                    <div class="text-price">
                        <span>¥</span>{{scope.row.price}}
                    </div>
                    <!--已收款-->
                    <div class="text-paid" v-if="scope.row.price_pay>0">
                        <span>{{storeInfo.type==3||scope.row.broker>0?scope.row.broker==0?'已收款':'代收款':'已支付'}}: </span>  
                        <p class="text-pay text-lis" v-if="scope.row.broker==0"><span class="text-offset_pay">¥</span>{{scope.row.price_pay/100>scope.row.price&&scope.row.broker>0?scope.row.price:scope.row.price_pay/100}}</p>
                        <p class="text-pay text-lis" v-else>¥{{scope.row.price_pay/100}}</p>
                    </div>
                    <!--未收款-->
                    <div class="text-paid" v-if="scope.row.offset_pay>0&&scope.row.price_pay>0">
                        <span>{{storeInfo.type==3?'待收款':'未支付'}}: </span>
                        <p class="text-pay "> <span class="text-offset_pay">¥</span>{{scope.row.offset_pay/100}}</p>
                    </div>
                </div>
              <!--其他-->
              <div :class="{'text-center':item.center}" v-else>{{ scope.row[item.prop]}}</div>
            </template>
          </el-table-column>
            <!--操作按钮-->
            <el-table-column
              fixed="right"
              header-align="center"
              label="操作"
              width="130">
              <template slot-scope="scope">
                <div class="text-center ">
                  <el-button  @click="goForDetail(scope.row)"  size="small" style="display: block; margin: 0 auto;" class="btn-sls">订单详情</el-button>
                  <!--确认单列表不显示此按钮-->
                  <template v-if="!confirm">
                    <div class="mb-1 mt-1" v-if="scope.row.send_receipt||scope.row.offer_receipt">
                        <el-popover
                            v-if="scope.row.send_receipt&&scope.row.offer_receipt"
                            placement="top-start"
                            trigger="hover"
                            >
                            <ul class="invoiceClass">
                                <li @click="uploadInvoice({receipt:scope.row.send_receipt,type:2,item:scope.row})"><span>旅行社发票</span> <i class="el-icon-arrow-right"></i></li>
                                <li @click="uploadInvoice({receipt:scope.row.offer_receipt,type:3,item:scope.row})"><span>酒店发票</span> <i class="el-icon-arrow-right"></i></li>
                            </ul>
                            <div class=" cursor-fapiaoguanli" slot="reference">
                                <el-button   size="small"  class="btn-pay ">查看发票</el-button>
                            </div>
                        </el-popover>
                        <el-button  @click="uploadInvoice({receipt:scope.row.send_receipt||scope.row.offer_receipt,type:scope.row.send_receipt?2:3,item:scope.row})"  v-else size="small"  class="btn-pay ">查看发票</el-button>
                    </div>
                    <!--删除订单按钮-->
                    <el-button  @click="deleteOrder(scope.row,1)"  type="text" size="small" v-if="$GFUN.isInArray([99,97],scope.row.status||scope.row.offer_status)&&status!=66" class="btn-pay btn-delete">删除订单</el-button>
                    <div class="mt-1">
                        <el-button  @click="submitFinance(scope.row)"  size="small" v-if="paymentDisplay(scope.row)" class="btn-pay btn-confirm">提交{{storeInfo.level==3?'打款':'财务'}}</el-button>
                    </div>
                    <!--平台打款按钮-->
                    <el-tooltip class="item" content="平台打款处理中，请耐心等待" placement="top-start">
                            <el-button  type="text" size="small" v-if="scope.row.pay_hotel_handle_travel==1" class="btn-pay btn-reminder mt-1">打款申请中</el-button>
                    </el-tooltip>
                    <!--平台打款按钮-->
                    <el-tooltip class="item" content="平台打款处理中，请耐心等待" placement="top-start">
                            <el-button  type="text" size="small" v-if="scope.row.pay_flag_hotel==1||scope.row.pay_hotel_handle_travel==2" class="btn-pay btn-reminder mt-1">平台待打款</el-button>
                    </el-tooltip>
                    <!--平台已打款按钮-->
                    <el-button  type="text" size="small"   v-if="scope.row.pay_flag_hotel==2" class="btn-pay mt-1" @click="handleCommand(scope.row)">平台已打款</el-button>
                    <!--回收站按钮-->
                    <el-popover
                        placement="bottom"
                        class="btn-delete"
                        trigger="hover">
                        <p class="recycle-delete mb-2" @click="$emit('deleteOrder',scope.row,3)">删除订单</p>
                        <p class="recycle-delete" @click="$emit('restoreOrder',scope.row)">还原</p>
                        <el-button  slot="reference"  type="text" size="small"  class="btn-pay btn-delete" v-if="status==66">更多<i class="el-icon-arrow-down"></i></el-button>
                    </el-popover>
                  </template>
                </div>
              </template>
            </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog title="打款回单" :visible.sync="dialogVisible"  width="1400px" class="paymentist">
        <Receipt :receiptInfo="receiptInfo"></Receipt>
    </el-dialog>
  </div>
</template>

<script>
    import Receipt from '@/views/Admin/FinancialManage/FinancialStats/Receipt.vue'
    import { mapGetters,mapState,mapActions } from 'vuex'
    import { debounce } from "lodash";
    export default {
    name: '',
    components: {Receipt},
    props: {
        orderList: {
            type: Array,
            default: () => [],
        },
        //确认单标识
        confirm: {
            type: Boolean,
            default: false,
        },
        //订单状态
        status: {
            type: Number,
            default: 4,
        },
    },
    data() {
        return {
            formData:{
                page:1,
                status:4,
            },
            list: [],
            total: 0,
            loading: false,
            tableData:[
                {name:'团号/订单号',prop:'oid',width:180, pattern:'oid'},   
                {name:'订单类型',prop:'order_type', minWidth:100,center:true,pattern:'order_type'},
                {name:'供应商',prop:'hotel_title',width:350,center:true,pattern:'hotel_title'},
                // {name:'发布时间',prop:'add_time',width:180,center:true,pattern:'time'},
                // {name:'团号',prop:'title', minWidth:200,center:true},
                // {name:'询价城市',prop:'city_name', minWidth:100,center:true},
                {name:'入离时间',prop:'store_list',center:true, minWidth:200,pattern:'date_in'},
                {name:'人数/晚数',prop:'store_list',center:true, minWidth:80,pattern:'num'},
                {name:'房型/间数',prop:'store_list', minWidth:300,pattern:'store_list'},
                {name:'单价',prop:'offer_price', minWidth:80,pattern:'offer_price'},
                {name:'核房/支付人',prop:'appoint_store_name', minWidth:250,pattern:'verify_arr'},
                {name:'金额',prop:'price', center:true,minWidth:110,pattern:'price'},
                {name:'状态',prop:'status', minWidth:140 ,center:true,pattern:'status'},
                {name:'标记',prop:'mark_info', minWidth:60,center:true,pattern:'mark_info'},
            ],
            isAdmintableData:[
                {name:'采购商',prop:'hotel_title',width:280,center:true,pattern:'supplier_title'},
                {name:'订单类型',prop:'order_type', minWidth:100,center:true,pattern:'order_type'},
                {name:'团号/订单号',prop:'oid',width:180, pattern:'oid'},   
                {name:'供应商',prop:'hotel_title',width:280,center:true,pattern:'hotel_title'},
                // {name:'发布时间',prop:'add_time',width:180,center:true,pattern:'time'},
                // {name:'团号',prop:'title', minWidth:200,center:true},
                // {name:'询价城市',prop:'city_name', minWidth:100,center:true},
                {name:'入离时间',prop:'store_list',center:true, minWidth:200,pattern:'date_in'},
                {name:'人数/晚数',prop:'store_list',center:true, minWidth:80,pattern:'num'},
                {name:'房型/间数',prop:'store_list', minWidth:300,pattern:'store_list'},
                {name:'单价',prop:'offer_price', minWidth:80,pattern:'offer_price'},
                {name:'核房/支付人',prop:'appoint_store_name', minWidth:250,pattern:'verify_arr'},
                {name:'金额',prop:'price', center:true,minWidth:110,pattern:'price'},
                {name:'状态',prop:'status', minWidth:140 ,center:true,pattern:'status'},
                {name:'标记',prop:'mark_info', minWidth:60,center:true,pattern:'mark_info'},
            ],
            dialogVisible2: false,
            //标记信息
            travel:[
                {name:'管',type:99},
                {name:'旅',type:2},
                {name:'酒',type:3},
            ],
            breakfastArr:[
                {name:'delete',id:0},
                {name:'red',id:1},
                {name:'Orange',id:2},
                {name:'green',id:3},
                {name:'greys',id:4},
                {name:'purple',id:5}
            ],
            //打款回执单开关
            dialogVisible: false,
            receiptInfo:{},
        };
    },
    computed: {
        ...mapState(['userLoginMessage']),
        ...mapGetters(['storeInfo', 'userInfo', 'isAdmin', 'isGroup']),
    },
    watch: {
        'storeInfo.type':{
            handler(newVal,oldVal){
                // if(newVal==99){
                //     this.tableData[2].name='供应商/采购商';
                //     this.tableData[2].width=450;
                // }
                if(newVal==3){
                    this.tableData[2].name='采购商';
                }
            },
            immediate:true
        }
    },
    created() {},
    mounted() {},
    methods: {
        ...mapActions(['adminPaymentInfor']),
        orderStatusArr() {
            switch (this.storeInfo.type) {
                case 99:
                case 2: return 'TOrderStatus';
                case 3: return 'HOrderStatus';
                default:return '';
            }
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (row.order_type === 2 && columnIndex === (this.isAdmin?4:3)) {
            // 起始单元格：行1，跨4列
            return {    
                rowspan: 1,
                colspan: 4
            }
            }
            // // 后面3列（索引2、3、4）隐藏
            let includes = this.isAdmin? [4,5,6,7]:[3,4,5,6] ;
            if (row.order_type === 2 && includes.includes(columnIndex)) {
            return {
                rowspan: 0,
                colspan: 0
            }
            }
            // 默认不合并
            return {
            rowspan: 1,
            colspan: 1
            }
        },
        //返回背景颜色clss
        getStatusClass(status){
            switch (status) {
                case 5:
                case 6:
                return 'status_6';
                case 7:
                return 'status_7';
                case 8:
                return 'status_8';
                case 9:
                return 'status_9';
                case 97:
                case 99:
                return 'status_99';
                default:
                return '';
            }
        },
        /*显示标注按钮*/
        showCommentBtn (e) {
            let t = this.storeInfo.type;
            if(t=='99'){
                return true
            }else{
                if(e==t) return true
            }
        },
        flagson(n,row) {
            let {breakfastArr}=this;
            switch (n) {
                case 99: return breakfastArr[row.admin_flag||0].name;
                case 2:  return breakfastArr[row.travel_flag||0].name;
                case 3:  return breakfastArr[row.hotel_flag||0].name;
            }
        },
        /**
         * 管理员判断订单显示提交财务条件
         */
        paymentDisplay(cardItem){
            let status=this.$GFUN.isInArray([6,7,8,9],cardItem.status);
            let price=cardItem.price_pay>0&&cardItem.pay_hotel_handle_travel==0|| cardItem.price_pay>0&&cardItem.pay_flag_hotel==0;
            return price&&status&&cardItem.edit_status!=1;
        },
        //管理员提交财务
        submitFinance(cardItem){
            this.$emit('openFinance',cardItem);
        },
        /*跳转查看订单详情页*/
        goForDetail(cardItem) {
            this.$router.push({
                name: 'OrderDetail',
                query: {
                    orderId: cardItem.oid,
                    match_store_id: cardItem.match_store_id,
                }
            });
            // window.open(routeUrl.href, '_blank');
        },
        //查看回执单
        handleCommand(Itemize) {
            this.adminPaymentInfor({
                data:{pay_id:Itemize.pay_id_hotel},
                successFun: (res) => {
                    this.receiptInfo=res;
                    this.dialogFormVisible=true;
                }
            })
        },
        //查看上传发票
        uploadInvoice(item){
            this.$emit('uploadInvoice',item);
        },
        /**
         * 删除订单
         */
        deleteOrder(row){
            this.$emit('deleteOrder',row);
        },
    },
};
</script>

<style lang="scss" scoped>
    .load-ar{
        background-color:inherit !important;
        padding:0 !important;
        min-width: 1200px;
    }
    .text-psis{
        background-color: #f5f5f5;
        color: #6e7789;
        padding: 4px 6px;
        border-radius: 4px;
        font-size: 12px;
        display:inline-block;
    }
    .text-man{  
        background-color: var(--smtc-color-primary);
        color: var(--smtc-color-white);
    }
    .text-woman{
        background-color: var(--smtc-color-warning);
        color: var(--smtc-color-white);
    }
    .text-sm{
        background-color: var(--smtc-color-text-back);
        color: var(--smtc-color-white) !important;
    }
    .text-confirm{
        background-color: var(--smtc-color-text-paleRed);
        color: var(--smtc-color-white) !important;
    }
    .text-direct{
        background-color: #ffe8c5;
        color: var(--smtc-color-warning);
        // color: var(--smtc-color-warning);
    }
    .text-ellipsis{
        display: flex;
        justify-content:center;
        div{
            text-align: left; 
        }
    }
    .date-tiem{
        background-color: var(--smtc-color-TextBackground-grayBlue);
        padding: 6px 10px;
        border-radius: 4px;
        font-size: 12px;
    }
    .room-item{
        display: flex;
        justify-content:left;
        margin-bottom: 0.5rem;
        >div{

            width: 215px;
            padding:4px 5px;
            margin-right: 0.5rem;
            text-align: center;
            border-radius: 4px;
            font-size: 12px;
            display: flex;
            justify-content:left;
            text-align: left;
            >div{
                display: flex;
                justify-content:left;
            }
            &:last-child{
                margin-right: 0;
            }
        }
        &:nth-child(2){
            margin-bottom:0;
        }
    }
    .reds{
        margin-left:auto;
        font-size: 14px ;
        color: var(--smtc-color-text-red);
        span{
            font-size: 8px;
        }
    }
    .text-ell{
        display: flex;
        justify-content:center;
    }
    .text-left{
        margin-left: 6%;
    }
    .room-type{

        font-size: 12px;
        display: flex;
    }
    .el-icon-room{
        margin-top: 8px;
        font-size: 12px;

        i{
            margin-right: 4px;
            font-size: 12px;
        }
    }

    @media (max-width:2150px){

        .room-item>div:nth-child(2){
            display: none;
        }
        .text-ell{
            display: flex;
            margin-left: 3%;
        }
    }
    .el-pagination{
        background-color: #fff;
        margin-top:14px;
        padding-bottom:10px;
    }
    .travel_title{
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: left !important;
        img{
            margin-right: 10px;
        }
        span{
            font-weight: bold;
        }
        p{
            font-size: 12px;
            background-color: #f5f5f5;
            padding:2px 8px;
            margin-top: 2px;
        }
    }
    .hotel{
        font-weight: bold;
        color: var(--smtc-color-text-red);
        margin-right: 2px;
    }   
    .list-unstyled{
        li{
            background-color: #f5f5f5;
            padding: 10px 20px;
            margin-bottom: 10px;
            border-radius: 4px;
            text-align: left;
            cursor: pointer;
        }
        .text-active{   
            color: var(--smtc-color-primary);
            position: relative;
            
        }
        .text-active::after{
            content: '';
            position: absolute;
            bottom: 25%;
            left: 10px;
            width: 2px;
            height: 50%;
            background-color: var(--smtc-color-primary);
            border-radius: 0 0 4px 4px;
        }
    }
        
    .list-bttom{
        margin-top: 20px;
    }
    .check-icon{
        float: right;
        font-size: 16px;
        font-weight: bold;
    }
    .datein{
        color: var(--smtc-color-primary);
    }
    .hotel-info{
        display: flex;
        align-items: center;
        text-align: left !important;
        justify-content: left;
        width: 85%;
        img{
            margin-right: 6px;
            border-radius: 4px;
        }
    }
    .offer_name{
        font-size: 12px;
        color: #666;
        margin-top: 4px;
        div{
            line-height: 20px;
        }
        i{
            font-size: 12px;
            margin-right: 4px;
        }
    }
    .tiem-oid{
        font-size: 12px;
        color: #999;
        margin-top: 2px;
    }
    .text-status{
        display: inline-block;
        width: 60px;
        padding: 2px 0;
        font-size: 12px;
        border-radius: 4px;
    }
    .verify_arr{
        display: flex;
        justify-content: center;
        >div{
            width: 50%;
            text-align: center;
        }
        >div:nth-child(1){
            border-right: 1px solid #eee;
        }
    }
    .not-added{
        display: inline-block;
        width: 60px;
        padding: 2px 0;
        font-size: 12px;
        border-radius: 4px;
        background-color: var(--smtc-color-TextBackground-grayBlue);
        color: #999;
    }
    //订单状态颜色
    .status_6{
        background-color:#fae7eb;
        color: #e46269;
    }
    .status_7{
            background-color:#fee4ce;
        color: #fc8346;
    }
    .status_8{
        background-color:#e6f8ea;
        color: #16ad3c;

    }
    .status_9{
        background-color:#bfdffe;
        color: #1672fe;
    }
    .status_99{
        background-color: var(--smtc-color-TextBackground-grayBlue);
        color: #999;
    }
    .el-icon-s-flag{
        cursor: pointer;
    }
    .verify-item{
        display: inline-block;
        cursor: pointer;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        border-radius: 4px;
        padding: 2px 4px;
        width:auto;
        margin: 0 auto;
        background-image: linear-gradient(to right, #e3f1fe , var(--smtc-color-TextBackground-grayBlue));
        margin-bottom: 10px;
        width: 105px;
        span{
            display:flex;
        }
    }
    .verify-type{
         height: 24px;
         font-size: 12px;
         border-radius: 4px;
         padding:0 4px;
        i{
            color:var(--smtc-color-primary);
            font-size: 12px;
            margin-right: 4px;
            
        }
    }
    .text-psoman{
        width: 40px;
    }
    .verify-name{
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        margin-left: 4px;
        width: 55px;
        text-align: left;

        display: inline-block;
    }
    .hotel-img{
        width: 64px;
        height: 64px;
    }   
    .hotel-name{
        text-align: left;
        margin-bottom: 4px;

        border-radius: 4px;
        align-items: center;        
    }
    .text-price{
        font-size: 14px;
        font-weight: bold;
        margin-right: 2px;
        color:#333;
        span{
            font-size: 10px;
            font-weight: normal;
        }
    }
    .text-paid{
        font-size: 12px;
        display: flex;
        justify-content: center;
    }
    .text-offset_pay{
        font-size: 9px;
    }
    .text-pay{
        width: 45px;
        text-align: right;
        font-weight: bold;
        font-size: 12px;
        color: red;
    }
    .text-lis{
        color:var(--smtc-color-green);
    }
    .min-wdei{
        min-width:28px;
        display: inline-block;
        padding: 0 10px;
    }
    .meet-red{
        font-size: 12px;
        .red{
            color: var(--smtc-color-text-red);
            font-size: 12px;
            font-weight: bold;
            span{
                font-size: 8px;
            }
        }
    }
    .straveln{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .quan{
        font-size: 12px;
        margin-right: 4px;
    }
    .btn-pay{
        color: var(--smtc-color-green);
        margin:0 !important;
        font-size: 12px;
        display: inline-block;
    }
    .btn-reminder{
        color: var(--smtc-color-text-red);
    }
    .hotel-info-title{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .leftAndRight{
        justify-content: space-between;
    }
    .offer_lis{
        display: flex;
        align-items: center;
        justify-content: left;
    }
    .icon-fapiaoguanli{
        font-size: 14px !important;
        margin-left: 4px;
        color: var(--smtc-color-primary);
    }
    .hotel-isdmin{
        justify-content: left !important;
    }
    .btn-confirm{
        color: var(--smtc-color-text-paleRed);
    }
    .invoiceClass li{
        display: flex;
        justify-content:space-between;
        padding: 6px 0;
        cursor: pointer;
    }
    .invoiceClass li span{
        font-size: 12px;
        font-weight: bold;
    }
    .invoiceClass li i{
        color: #999;
        font-size: 12px;
        margin-top: 2px;
    }
    .modify{
        font-size: 12px;
    }
    .dlestl{
        font-size: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        a{
            background-color: red;
            color: #fff;
            margin-left: 4px;
            width: 14px;
            height: 14px;
            line-height: 14px;
            border-radius: 50px;
            font-size: 10px;
            text-align: center;
            display: inline-block;
        }
    }
    .btn-sls{
        color: var(--smtc-color-primary);
    }
    .btn-delete{
        color: #666;
    }
    .recycle-delete{
        font-size: 12px;
        text-align: center;
        color: #333;
        cursor: pointer;
    }
    .text-cancel{
        font-size: 12px;
        margin-top: 10px;
        color: #999;
    }
    .dlis{
        font-size: 12px;
    }
    .room-img{
        width: 20px;
        border-right: 2px solid #f7f7f9;
        padding-right: 2px;
        margin-right: 4px;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        img{
            width: 100%;
        }
    }
    .offer_title{
        width: 120px;
        margin-left: 4px;
    }
    .room-num{
        width: 40px;
        display: flex;
        justify-content:flex-end !important;
    }
    .offer_price{
        margin-left: auto;
        font-weight: bold;
    }
    .text-fw{
        font-weight: bold;
    }
</style>
<style>
     .el-popover{
        min-width: 80px !important; 
    }
</style>